import { useTranslation } from 'react-i18next';
import { AutocompleteField } from '@/components/common';
import { V90_CITY_SUGGESTIONS } from '@/constants';
import { SimpleTextFieldProps } from '../common/RadixProps';

export interface CityFieldProps extends SimpleTextFieldProps {
  value: string;
  error?: string;
}

export function CityField({ value, onChange, error, ...rest }: CityFieldProps) {
  const { t } = useTranslation('onboarding');
  const queryTrimmed = value.trim();
  const queryLower = queryTrimmed.toLowerCase();
  const isExactMatch = V90_CITY_SUGGESTIONS.some(c => c.toLowerCase() === queryLower);
  const suggestions =
    queryTrimmed.length > 0 && !isExactMatch
      ? V90_CITY_SUGGESTIONS.filter(
          c => c.toLowerCase().includes(queryLower) && c.toLowerCase() !== queryLower
        ).slice(0, 8)
      : [];

  return (
    <AutocompleteField
      {...rest}
      value={value}
      onChange={onChange}
      error={error}
      autoComplete="address-level2"
      placeholder={t('steps.city.placeholder')}
      aria-label={t('steps.city.fieldLabel')}
      aria-invalid={error ? true : undefined}
      options={suggestions.map(city => ({ id: city, label: city }))}
      onSelectOption={option => onChange(option.label)}
    />
  );
}
